export enum CDButtonType {
  Primary = "btn-primary",
  Secondary = "btn-secondary",
  Tertiary = "btn-tertiary",
  Success = "btn-success",
  Warning = "btn-warning",
  Danger = "btn-danger",
  Info = "btn-info",
  PrimaryOutline = "btn-outline-primary",
  SecondaryOutline = "btn-outline-secondary",
  SuccessOutline = "btn-outline-success",
  WarningOutline = "btn-outline-warning",
  DangerOutline = "btn-outline-danger",
  InfoOutline = "btn-outline-info",
  Borderless = "btn-borderless",
  BorderlessSecondary = "btn-borderless-secondary",
  NotificationBar = "btn-notification-bar",
  OutlineTransparent = "btn-outline-transparent",
}
